import { render, staticRenderFns } from "./LongVideo.vue?vue&type=template&id=f89439ca&scoped=true&"
import script from "./LongVideo.vue?vue&type=script&lang=js&"
export * from "./LongVideo.vue?vue&type=script&lang=js&"
import style0 from "./LongVideo.vue?vue&type=style&index=0&id=f89439ca&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f89439ca",
  null
  
)

export default component.exports